import { ConfigurationApi } from '@/service/api'

class ConfigurationRepository {
   public async isMobileScannerDisabled () {
      return await configurationApi.isMobileScannerDisabled()
         .then(response => response.data)
   }
}

const configurationApi = new ConfigurationApi()
const configurationRepository = new ConfigurationRepository()
export default configurationRepository
